import { CtaButton, OrganicTeamMember } from 'themes/organic/components';
import { ContainedSection } from 'themes/organic/components/sections/ContainedSection';
import { StaggeredList } from 'themes/organic/components/StaggeredList';

import { TProfessional } from 'types/appointment';

import s from './TeamSection.module.css';

type TProps = {
  professionals: TProfessional[];
  onProClick: (professional: TProfessional) => void;
};

export const TeamSection = ({ professionals, onProClick }: TProps) => {
  return (
    <ContainedSection title="Team" id="team" contentClassName={s.container}>
      <StaggeredList
        id="team-members"
        items={professionals}
        renderItem={(item) => (
          <OrganicTeamMember
            professional={item as TProfessional}
            onClick={onProClick}
          />
        )}
      />
      <CtaButton href="/team" style={2} title="view full team">
        view full team
      </CtaButton>
    </ContainedSection>
  );
};
